export default {
  setModalState({ commit }, newModalState) {
    commit('SET_MODAL_STATE', newModalState)
  },
  setEmergeMode({ commit }, newModalState) {
    commit('SET_EMERGE_MODE', newModalState)
  }
}
